<template>
<div>
    <div id="wrapper" v-if="isStandalone === true">

        <div id="content-wrapper" class="d-flex flex-column">
            <div id="content">

                <TopBar :logo="site.image_header" :baseline="site.name"></TopBar>

                <router-view></router-view>

            </div>
        </div>
    </div>
    <div v-else>
        <router-view></router-view>
    </div>
</div>
</template>

<style>
#content {
    min-height: 100vh;
}

.grecaptcha-badge {
    display: none;
}
</style>

<script>
//UI Component
import TopBar from '@/components/UI/TopBar.vue'
import FooterApplication from '@/components/UI/FooterApplication.vue'
import ScrollToTop from '@/components/UI/ScrollToTop.vue'
import Toast from '@/components/UI/Toast.vue'

//Form Component
import StepManager from '@/components/Form/StepManager.vue'
import Wizard from '@/components/Form/Wizard.vue'

//Services
import {
    PreferenceService
} from '@/service/PreferenceService.js'

export default {
    name: 'App',
    props: {
        form: {
            type: Number,
            required: true,
            description: "ID du formulaire à afficher"
        },
        showStepmanager: {
            type: Boolean,
            required: false,
            default: false,
            description: "Doit-on afficher le Step Manager ?"
        },
        isAnonymous: {
            type: Boolean,
            required: false,
            default: false,
            description: "Doit-on anonymiser le signalement avant de l'envoyer ?"
        },
        redirect: {
            type: String,
            required: false,
            default: '/',
            description: "Url de redirection quand le formulaire est envoyé avec succès"
        },
        vueAppBackendUrl: {
            type: String,
            required: true,
            description: "Url du backend Platform"
        },
        vueAppModernApiUrl: {
            type: String,
            required: true,
            description: "Url du backend Refresh"
        },
        vueAppBaseUrl: {
            type: String,
            required: true,
            description: "Url de l'application Vue (cette application)"
        },
        vueAppMapCountryRestrict: {
            type: String,
            required: false,
            default: 'France',
            description: "Filtrer les résultats de la carte par pays"
        },
        vueAppMapCityRestrict: {
            type: String,
            required: false,
            default: 'Paris',
            description: "Filtrer les résultats de la carte par ville"
        },
        consultUrl: {
            type: String,
            required: false,
            description: "Url de consultation des cartes"
        }
    },
    components: {
        TopBar,
        FooterApplication,
        Toast,
        ScrollToTop,
        PreferenceService,
        StepManager,
        Wizard
    },
    data: function () {
        return {
            isStandalone: JSON.parse(process.env.VUE_APP_STANDALONE || "false"),
            site: {}
        }
    },
    created() {
        this.$store.commit("setFormId", this.form);
        this.$store.commit("setStepmanager", this.showStepmanager);
        this.$store.commit("setAnonymous", this.isAnonymous);
        this.$store.commit("setRedirectPage", this.redirect);
        this.$store.commit("setConsultUrl", this.consultUrl);
        this.$store.commit("setVueAppBackendUrl", this.vueAppBackendUrl);
        this.$store.commit("setVueAppModernApiUrl", this.vueAppModernApiUrl);
        this.$store.commit("setVueAppBaseUrl", this.vueAppBaseUrl);
        this.$store.commit("setMapCountryRestrinction", this.vueAppMapCountryRestrict);
        this.$store.commit("setMapCityRestrinction", this.vueAppMapCityRestrict);
        
        var that = this;
        PreferenceService.setEndpoints(this.$store.state.vueAppBackendUrl, this.$store.state.vueAppModernApiUrl);
        PreferenceService.getPreference(function (response) {
            that.site = response[1];

            that.$store.commit("setMap", response[2]);
        });

	//if token present in the URL, then fill the token variable and set a cookie
	var token;
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            token = this.$route.query.token;

	    this.$cookie.set('gestionnaire', token, { expires: '1h' });

	}
	else if (this.$cookie.get('gestionnaire') && this.$cookie.get('gestionnaire').length > 0) {

	    token = this.$cookie.get('gestionnaire');

	}

	if (token && token.length >0 ) {

            PreferenceService.getUser(token, function (response) {
                that.$store.commit("setUser", response.data);
                that.$store.commit("setToken", token);
            });
        }
    }
}
</script>
